// M3 economy & politics actions for core/actions.js (each returns { ok, msg } and mutates state).
import { placeBidImpl, applyLicenceImpl, withdrawBidImpl, acceptConcessionImpl } from './leaserounds.js';
import { setBuybackImpl } from './nationalize.js';
import { sellForwardImpl, openFutureImpl, buyPutImpl, closeHedgeImpl } from './hedging.js';
import { chooseRouteImpl } from './routes.js';
import { prepareSafetyCaseImpl } from './regimes.js';
export { M3_ECON_DECISION_KINDS, resolveM3EconDecision } from './econtick.js';

export const placeBid = (state, roundId, tract, amount, opts = {}) => placeBidImpl(state, roundId, tract, amount, opts ?? {});
export const applyLicence = (state, roundId, tract, wells) => applyLicenceImpl(state, roundId, tract, wells);
export const withdrawBid = (state, roundId, tract) => withdrawBidImpl(state, roundId, tract);
export const acceptConcession = (state, fieldId) => acceptConcessionImpl(state, fieldId);
export const setBuyback = (state, regionId, on = true) => setBuybackImpl(state, regionId, on);
export const sellForward = (state, opts = {}) => sellForwardImpl(state, opts);
export const openFuture = (state, opts = {}) => openFutureImpl(state, opts);
export const buyPut = (state, opts = {}) => buyPutImpl(state, opts);
export const closeHedge = (state, id) => closeHedgeImpl(state, id);
export const chooseRoute = (state, fieldId, choice = null) => chooseRouteImpl(state, fieldId, choice);
export const prepareSafetyCase = (state, fieldId) => prepareSafetyCaseImpl(state, fieldId);
